let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("irHqQ")).then(() => parcelRequire('s579P'));